import { FC } from 'react';
import { Avatar } from 'antd';
import { TbDatabaseSearch } from 'react-icons/tb';

import { BoxSVGIcon, DropboxSVGIcon, GoogleDriveSVGIcon, MicrosoftOneDriveSVGIcon } from '@/assets';
import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { CloudStorageConnection } from '@/services';
import { imgLogoStyling } from '@/theme';
import { ConnectedAccountType } from '@/types';

interface CloudStorageConnectionAvatarProps {
    connection: Partial<CloudStorageConnection>;
    size?: number;
}

const providerIcons: Partial<Record<ConnectedAccountType, string>> = {
    [ConnectedAccountType.BOX]: BoxSVGIcon,
    [ConnectedAccountType.DROPBOX]: DropboxSVGIcon,
    [ConnectedAccountType.GOOGLE_DRIVE]: GoogleDriveSVGIcon,
    [ConnectedAccountType.MICROSOFT_ONEDRIVE]: MicrosoftOneDriveSVGIcon,
};

const CloudStorageConnectionAvatar: FC<CloudStorageConnectionAvatarProps> = ({ connection, size = 24 }) => {
    const { token } = useAntDesignTheme();
    const providerIcon = connection.type ? providerIcons[connection.type as ConnectedAccountType] : undefined;

    return (
        <Avatar
            icon={
                providerIcon ? (
                    <img alt='' src={providerIcon} style={{ ...imgLogoStyling, transform: 'scale(0.75)' }} />
                ) : (
                    <TbDatabaseSearch style={{ color: token.colorTextTertiary }} />
                )
            }
            shape='square'
            size={size}
            style={{ backgroundColor: token.colorBgBase, border: `1px solid ${token.colorBorder}` }}
        />
    );
};

export default CloudStorageConnectionAvatar;
